import { withRouter } from 'react-router-dom';
import ImageBanner from './ImageBanner';

export default withRouter(ImageBanner);
